// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { UIFieldSetModel, UIWorkFieldModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-set',
  template: `
  <span *ngIf="workItem$ && fieldSetId" [ngSwitch]="style.current()">
    <e5core-ui-work-field-set-box *ngSwitchCase='0' [workItem$]='workItem$' [fieldSet]='fieldSet' [fields]='fields' [readonly]='readonly'></e5core-ui-work-field-set-box>
    <e5core-ui-work-field-set-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [fieldSet]='fieldSet' [fields]='fields' [readonly]='readonly'></e5core-ui-work-field-set-bootstrap>
    <e5core-ui-work-field-set-material *ngSwitchCase='2' [workItem$]='workItem$' [fieldSet]='fieldSet' [fields]='fields' [readonly]='readonly'></e5core-ui-work-field-set-material>
  </span>
  <div *ngIf="!(workItem$ && fieldSetId)" class="e5core-component-error">&lt;e5core-ui-work-field-set&gt; [fieldSetId] must be > 0 and [workItem$] must have a BehaviorSubject&lt;WorkItemModel&gt;</div>`,
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldSetComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() fieldSetId: number;
  @Input() readonly: boolean;

  workItemModel: WorkItemModel ;
  fieldSet: UIFieldSetModel ;
  fields: UIWorkFieldModel [] ;

  constructor(public style:UiStyleService, private cd: ChangeDetectorRef ) { }

  private updateFieldSetModel(fieldSetId: number) {
    this.fieldSet = null ;
    this.fields = [] ;
    if (this.workItemModel && this.workItemModel.fieldsets) {
      const fieldSet = this.workItemModel.fieldsets.find( fs => fs.fieldSetId == this.fieldSetId) ;
      if (fieldSet) {
        this.fieldSet = fieldSet ;
        this.fields = fieldSet.fields;
      } else {
        console.error(`fieldSetId ${this.fieldSetId} not found in workItem$`) ;
      }
    } else {
      console.error(`No fieldsets in workItem$`) ;
    }
    this.cd.markForCheck();
  }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-field-set [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    if (this.fieldSetId == null) {
      console.error('e5core-ui-work-field-set [fieldSetId] must have a number value');
      return ;
    }
    this.workItem$.subscribe(
      wi => {
        this.workItemModel = wi ;
        this.updateFieldSetModel(this.fieldSetId) ;
        this.cd.markForCheck() ;
      }
    );
  }

}
